import React from "react";
import classes from "./index.module.scss";
import classNames from "classnames";
import Draggable from "react-draggable";
import { useHistory } from "react-router-dom";
import { useKeyPressEvent } from "react-use";
import { GroupAnswerViewItem } from "../../../../../service/group";

interface FloatBtnProps {
    list: GroupAnswerViewItem[];
    selectedIndex: number;
    goPrev: () => void;
    goNext: () => void;
    isFullscreen: boolean;
    toggleFullScreen: () => void;
    showList: boolean;
    setShowList: (showList: boolean) => void;
}

export default function FloatBtn({
    list,
    selectedIndex,
    goPrev,
    goNext,
    isFullscreen,
    toggleFullScreen,
    showList,
    setShowList
}: FloatBtnProps) {
    const history = useHistory();

    useKeyPressEvent("ArrowLeft", goPrev);
    useKeyPressEvent("ArrowRight", goNext);

    function onGoBack() {
        history.goBack();
    }

    return (
        <Draggable handle={`.${classes.handle}`}>
            <div
                className={classNames([classes.root])}
                role="button"
                style={{ bottom: 40, left: "calc(50% + 250px)" }}>
                <div className={classes.main}>
                    {!showList && (
                        <div className={classes.navigate}>
                            {selectedIndex !== 0 && (
                                <span
                                    role="button"
                                    className={classes.prev}
                                    onClick={goPrev}>
                                    上一份
                                </span>
                            )}
                            <span
                                role="button"
                                className={classes.all}
                                onClick={() => setShowList(true)}>
                                全部任务
                            </span>
                            {selectedIndex !== list.length - 1 && (
                                <span
                                    role="button"
                                    className={classes.next}
                                    onClick={goNext}>
                                    下一份
                                </span>
                            )}
                        </div>
                    )}

                    {!isFullscreen && (
                        <span role="button" onClick={toggleFullScreen}>
                            <img src={require("./img/icon-screen.png")} /> 全屏
                        </span>
                    )}
                    {isFullscreen && (
                        <span role="button" onClick={toggleFullScreen}>
                            <img src={require("./img/icon-screen-out.png")} />{" "}
                            退出全屏
                        </span>
                    )}

                    <span
                        style={{ paddingLeft: 10 }}
                        role="button"
                        onClick={onGoBack}>
                        <img src={require("./img/icon-break.png")} /> 断开投屏
                    </span>
                </div>

                <div className={classes.handle} />
            </div>
        </Draggable>
    );
}
